@use '@/scss/underscore' as _;

.form {
  @include _.flex-column;

  > * {
    width: 100%;
  }

  .inputField,
  .link,
  .switch,
  .formErrors {
    margin-bottom: _.unit(4);
  }

  .link,
  .switch {
    align-self: start;
    width: auto;
  }

  .link {
    margin-top: _.unit(-1);
  }

  .formErrors {
    margin-left: _.unit(0.5);
    margin-top: _.unit(-3);
  }
}

:global(.desktop) {
  .form {
    .link {
      margin-top: _.unit(-2);
    }
  }
}
